module.exports = __webpack_public_path__ + "static/media/never-split.87346c6c.jpg";